// extracted by mini-css-extract-plugin
export default {"base":"ActionCancelMod_base__oXAL3","isDisabled":"ActionCancelMod_isDisabled__OwLdt"};